{
  "login": {
    "title": "Connectez-vous à la plateforme",
    "username": {
      "label": "Nom d'utilisateur",
      "placeholder": "johndoe"
    },
    "password": {
      "label": "Mot de passe",
      "placeholder": "Veuillez saisir votre mot de passe"
    },
    "remember_me": "Se souvenir de moi",
    "forgot_password": "Mot de passe oublié ?",
    "button": "Connexion"
  }
}
